import { configureStore, ThunkAction, Action, combineReducers } from '@reduxjs/toolkit';

import authReducer from '~/thunks/auth/authSlice';
import userReducer from '~/thunks/user/userSlice';
import notificationReducer from '~/thunks/notification/notificationSlice';
import courseReducer from '~/thunks/course/courseSlice';
import toastReducer from '~/thunks/toast/toastSlice';
import tuitionReducer from '~/thunks/tuition/tuitionSlice';
import examReducer from '~/thunks/exam/examSlice';
import quizReducer from '~/thunks/quiz/quizSlice';
import discussionReducer from '~/thunks/discussion/discussionSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  userState: userReducer,
  notificationState: notificationReducer,
  courseState: courseReducer,
  toastState: toastReducer,
  tuitionState: tuitionReducer,
  examState: examReducer,
  discussionState: discussionReducer,
  quizState: quizReducer,
});

export function makeStore() {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
    devTools: process.env.NODE_ENV !== 'production',
  });
}

const store = makeStore();

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;

export default store;
